/*
 * Copyright (c) 2020. Legalbird eine Marke der R+S Internet Jewels GmbH
 */
import React, { useState } from "react";
import ButtonLoading from "../Button/ButtonLoading";
import Grid from "@mui/material/Grid";
import ValidatorSelect from "../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import useForm from "../../hooks/useForm";
import { convertToFloat, formValue } from "../../services/formServiceFunctions";
import ApiClient from "../../services/ApiClient";
import { useSnackbar } from "notistack";

import ValidatorNumberField from "../Validator/ValidatorNumberField";

const ControllingForm = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async ({ values }: { values: Record<string, any> }) => {
    setIsLoading(true);
    const transformedValues = { ...values, cashBalance: convertToFloat(values.cashBalance) };
    const data = await ApiClient.post("services/pdf/create_controlling_document", {
      body: JSON.stringify(transformedValues),
    });
    let messageText = "Es wurde kein Dokument erstellt";
    if (data && data.status && data.electronicFileFolderId) {
      messageText = data.status === "ok" ? "Das Dokument wurde erstellt" : "Das Dokument kann nicht erstellt werden!";

      enqueueSnackbar(messageText, {

        variant: "custom",
        buttonText: "zum Dokument",
        buttonLink: "https://drive.google.com/drive/folders/" + data.electronicFileFolderId,
        linkIsExternal: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }
    setIsLoading(false);
  };

  const { values, handleChange, handleSubmit } = useForm({
    initialValues: {
      cashBalance: "",
      month: "",
      year: "",
    },
    onSubmit,
  });

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} sx={{
        alignItems: "center"
      }}>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ValidatorNumberField
            label={"Zielbetrag"}
            fieldType={"money"}
            numberType={"float"}
            name={"cashBalance"}
            value={formValue(values, "cashBalance")}
            onChange={handleChange}
            helperText={"Kontostand vom Monatsende."}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ValidatorSelect
            label={"Monat"}
            name={"month"}
            value={formValue(values, "month")}
            helperText={"Monat des abzurechnenden Zeitraums"}
            onChange={handleChange}
          >
            <MenuItem value={1}>Januar</MenuItem>
            <MenuItem value={2}>Februar</MenuItem>
            <MenuItem value={3}>März</MenuItem>
            <MenuItem value={4}>April</MenuItem>
            <MenuItem value={5}>Mai</MenuItem>
            <MenuItem value={6}>Juni</MenuItem>
            <MenuItem value={7}>Juli</MenuItem>
            <MenuItem value={8}>August</MenuItem>
            <MenuItem value={9}>September</MenuItem>
            <MenuItem value={10}>Oktober</MenuItem>
            <MenuItem value={11}>November</MenuItem>
            <MenuItem value={12}>Dezember</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ValidatorSelect
            label={"Jahr"}
            name={"year"}
            value={formValue(values, "year")}
            helperText={"Jahr des abzurechnenden Zeitraums"}
            onChange={handleChange}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value={2025}>2025</MenuItem>
            <MenuItem value={2026}>2026</MenuItem>
          </ValidatorSelect>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
            lg: 3
          }}>
          <ButtonLoading
            isLoading={isLoading}
            disabled={isLoading}
            type={"submit"}
            color={"primary"}
            variant={"contained"}
            fullWidth={true}
          >
            Abrechnung erstellen
          </ButtonLoading>
        </Grid>
      </Grid>
    </form>
  );
};

export default ControllingForm;
